import { ReactNode } from 'react'

import {
  EmployeesEmployeeNameQuickViewFragment,
  EmployeesEmployeeQuickViewFragment,
} from 'generated/resources/graphql'

import { Popover } from './Popover'

export type EmployeeQuickViewProps = {
  employee: EmployeesEmployeeQuickViewFragment | EmployeesEmployeeNameQuickViewFragment
  onViewProfile?: () => void
  usePreferredName?: boolean
  enabled?: boolean
}

export const EmployeeQuickView: React.FC<EmployeeQuickViewProps & { children: ReactNode }> = ({
  employee,
  onViewProfile,
  children,
  usePreferredName,
  enabled = true,
}) => {
  return (
    <Popover onViewProfile={onViewProfile} employee={employee} usePreferredName={usePreferredName}>
      {children}
    </Popover>
  )
}
